export default {
  SET_NOTIFICATION: (state, notification) => {
    state.notification = notification;
  },
  REMOVE_NOTIFICATION: (state) => {
    state.notification = null;
  },
  ADD_REQUEST: (state) => {
    state.pendingRequestsCount += 1;
  },
  REMOVE_REQUEST: (state) => {
    state.pendingRequestsCount =
      state.pendingRequestsCount > 0 ? state.pendingRequestsCount - 1 : 0;
  },
  SET_CONFIGURATIONS: (state, configurations) => {
    state.configurations = {
      ...configurations,
      student_information_form: configurations.student_information_form
        ? JSON.parse(configurations.student_information_form)
        : [],
      academic_procedure_form: configurations.academic_procedure_form
        ? JSON.parse(configurations.academic_procedure_form)
        : [],
      edit_enrollment_student_status:
        configurations.edit_enrollment_student_status
          ? JSON.parse(configurations.edit_enrollment_student_status)
          : [],
    };
  },
};
